module.exports = __webpack_public_path__ + "static/img/phoneBox.64d022f5.png";